export const localText = {
    MenuAriaLabel: 'User menu',
    SignOut: 'Sign out',
} as const;

export const USER_MENU_WIDTH = 250;
